import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: null,
};

// Tạo slice
const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});

// Xuất actions và reducer
export const { setCurrentPage } = generalSlice.actions;
export default generalSlice.reducer;